import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// 简化版的 cn (className) 工具函数
export function cn(...classes) {
  return twMerge(clsx(classes));
}
